import { render } from "./dxgledit.vue?vue&type=template&id=39b0829a&scoped=true"
import script from "./dxgledit.vue?vue&type=script&lang=js"
export * from "./dxgledit.vue?vue&type=script&lang=js"

import "./dxgledit.vue?vue&type=style&index=0&id=39b0829a&lang=scss&scoped=true"
import "./dxgledit.vue?vue&type=style&index=1&id=39b0829a&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b0829a"]])

export default __exports__